import { render, staticRenderFns } from "./MenuStandalone.vue?vue&type=template&id=3fcd5334&scoped=true&"
import script from "./MenuStandalone.vue?vue&type=script&lang=js&"
export * from "./MenuStandalone.vue?vue&type=script&lang=js&"
import style0 from "./MenuStandalone.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MenuStandalone.vue?vue&type=style&index=1&id=3fcd5334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcd5334",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VBadge,VIcon,VListItem,VListItemAction,VListItemContent})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fcd5334')) {
      api.createRecord('3fcd5334', component.options)
    } else {
      api.reload('3fcd5334', component.options)
    }
    module.hot.accept("./MenuStandalone.vue?vue&type=template&id=3fcd5334&scoped=true&", function () {
      api.rerender('3fcd5334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuStandalone.vue"
export default component.exports